module.exports = __webpack_public_path__ + "img/btn.920979c.png";


//////////////////
// WEBPACK FOOTER
// ./static/mobile/btn.png
// module id = 1Iz8
// module chunks = 1